import { render, staticRenderFns } from "./recommendQuestion.vue?vue&type=template&id=9417253e&scoped=true"
import script from "./recommendQuestion.vue?vue&type=script&lang=js"
export * from "./recommendQuestion.vue?vue&type=script&lang=js"
import style0 from "./recommendQuestion.vue?vue&type=style&index=0&id=9417253e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9417253e",
  null
  
)

export default component.exports